module.exports = {"500114001":"城东街道","500114002":"城南街道","500114003":"城西街道","500114004":"正阳街道","500114005":"舟白街道","500114006":"冯家街道","500114105":"阿蓬江镇","500114106":"石会镇","500114107":"黑溪镇","500114108":"黄溪镇","500114109":"黎水镇","500114110":"金溪镇","500114111":"马喇镇","500114112":"濯水镇","500114113":"石家镇","500114114":"鹅池镇","500114117":"小南海镇","500114119":"邻鄂镇","500114120":"白石镇","500114121":"中塘镇","500114122":"沙坝镇","500114123":"太极镇","500114124":"五里镇","500114125":"水市镇","500114246":"蓬东乡","500114249":"杉岭乡","500114251":"水田乡","500114252":"白土乡","500114253":"金洞乡","500114256":"新华乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500114.json
// module id = 2354
// module chunks = 0